<template>

  <v-card class="pa-6 ma-md-10 bg-white-show-through">

    <!-- title -->
    <v-card-title class="card-title">
      <v-icon large class="indigo--text mr-3">mdi-material-ui</v-icon>
      {{ $t('sadmin.global_ui_config.title')}}
    </v-card-title>

    <v-divider class="my-4"></v-divider>

    <v-card-text>

      <v-row>

          <AppAlert :alert="alert"/>

        <v-skeleton-loader v-if="isReady" v-bind="attrs" type="date-picker"></v-skeleton-loader>

        <v-col v-if="!isReady && config" cols="12">
          <v-form ref="form">


              <v-col cols="12" md="4" sm="6">
                <v-switch
                        v-model="config.enableBookingUI"
                        :label="$t('sadmin.global_ui_config.enableBookingUI')"
                        color="indigo"  @change="validateConfig"
                        inset>
                </v-switch>
              </v-col>


              <!-- mail auth -->
              <v-col cols="12" md="4" sm="6">
                <v-switch
                        v-model="config.enableActivitiesUI"
                        :label="$t('sadmin.global_ui_config.enableActivitiesUI')"
                        color="indigo" @change="validateConfig"
                        inset>
                </v-switch>
              </v-col>
          </v-form>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>

</template>

<script>
  import { Alert } from '@/shared/models';
  import { AppConfigApi } from '../../../shared/services/api/app-config'
  import { mapGetters } from 'vuex';
  export default {
    data () {
      return {
        config: null,
        isLoading: false,
        isReady: false,
        alert: null,
        attrs: {
          class: 'mb-6',
          boilerplate: true,
          elevation: 2
        }
      };
    },
    methods: {
      validateConfig () {
        this.isLoading = false;
        this.alert = null;
        return AppConfigApi.saveAppUIConfig(this.config)
          .then(response => {
            this.config = response;
            this.$store.commit('main/setUiConf', response)
            this.alert = new Alert({
              type: 'success',
              message: this.$t('shared.updateCorrect')
            });
          })
          .catch(error => this.alert = error)
          .finally(() => this.isLoading = false);
      },
      getConfig () {
        this.isReady = false;
        this.alert = null;
        this.config =this.uiConf;
      }
    },
    mounted () {
      this.getConfig();
    }, computed: {
      ...mapGetters({ uiConf: 'main/uiConf' })
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .box {
    margin-bottom: 0.4rem;
  }
</style>
